<template>
  <div class="container-fluid">
  <div class="row">
      <div class="col-md-12">
        <table-obras :obras='obras' @filterByTag='filterByTag($event)'></table-obras>
        <pagination :count='count' :limit='limit' :page='page' @changePage='changePage($event)'></pagination>
      </div>
  </div>
</div>
</template>
<script>

import ObraService from '../services/obra-service'
import { TableObras } from '@/components'
import { Pagination } from '@/components'
import OverlayService from '../services/overlay-service'

export default {
  components: {
    TableObras,
    Pagination
  },
  data () {
    return {
      limit: 10,
      obras: [],
      count: 0,
      page: 0
    }
  },

  mounted () {
    this.loadObras()
  },

  methods: {
    loadObras () {
      const order = [{ orderBy: 'titulo', direction: 'asc' }]

      const filter = {
        limit: this.limit,
        page: this.page + 1,
        orderBy: order,
        recomendado: 1
      }

      OverlayService.trigger('show', true)

      ObraService.getByTitle(filter)
        .then(response => response.data)
        .then(data => {
          this.obras = data.data
          this.count = data.total
          OverlayService.trigger('show', false)
        }).catch(er => OverlayService.trigger('show', false))
    },

    getOffset () {
      return this.limit * this.page
    },

    changePage (page) {
      this.page = page
      this.loadObras()
    }
  }
}
</script>
